import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { Relationship } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { MedicalItemFamilyHistory } from "@/Patient/Models/MedicalSummary/MedicalItemFamilyHistory";

import styles from "./FamilyHistorySection.module.css";

interface IFamilyHistorySectionProps {
    familyHistory: MedicalItemFamilyHistory[];
    onMedicalItemClick: (familyHistory: MedicalItemFamilyHistory, view: MedicalItemsTab) => void;
}

function FamilyHistorySection(props: IFamilyHistorySectionProps): JSX.Element {
    const visibleFamilyHistory = props?.familyHistory?.filter(history =>
        history.EMRTemplateIsVisibleInCPP && !history.EMRTemplateIsInvalid
    ) ?? [];

    return (
        <>
            {getFamilyHistoryRenderingElements(visibleFamilyHistory, props.onMedicalItemClick)}
        </>
    );
}

function getFamilyHistoryRenderingElements(
    familyHistory: MedicalItemFamilyHistory[],
    onMedicalItemClick: (familyHistory: MedicalItemFamilyHistory, view: MedicalItemsTab) => void
): JSX.Element[] {
    let renderingElements: JSX.Element[] = [];
    const otherRelationshipLookupId: string = cacheStore.FindLookupByLookupCode(Relationship.Other, Relationship.Code).LookupID;

    renderingElements = familyHistory.map((history, idx) => {
        let relationshipString = cacheStore.GetLocalizedValueByLookupId(history.RelationshipLookupId);
        const comma = (idx !== (familyHistory.length - 1)) ? " , " : "";

        if (!IsNullOrWhiteSpace(relationshipString)) {
            relationshipString = `(${relationshipString})`;
        }

        if (history.RelationshipLookupId == otherRelationshipLookupId) {
            relationshipString = `${relationshipString} : ${history.SpecifiedRelationship}`;
        }

        return (
            <a
                key={history.Id}
                onClick={() => onMedicalItemClick(history, MedicalItemsTab.FamilyHistory)}
                data-cy="family-history-item"
            >
                <span className={styles.problem}>{`${history.Problem} `}</span>
                <span className={styles.relationship}>{relationshipString}</span>
                {comma}
            </a>
        );
    });

    return renderingElements;
}

export { FamilyHistorySection };
